export default __webpack_public_path__ + "static/media/Bag of Engulfment.ae4431d4.jpg";